import styled from "styled-components";
import {
  InputCheckbox,
  Dialog,
  DialogScroll,
  Button,
} from "@ebscois/react-component-library";

export const DialogWrapper = styled(Dialog)`
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    align-items: center;
  }
  @media print {
    display: none;
  }
`;
export const DialogHeadingWrapper = styled.div`
  margin: 15px 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray400};
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 38px 20px 0;
    padding-bottom: 10px;
  }
`;
export const DialogSubHeadingWrapper = styled.div`
  margin: 0 10px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 20px;
  }
`;
export const DialogContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 20px 0;
  }
`;
export const SelectButton = styled(Button)`
  padding: 0;
  border-radius: unset;
  &:first-child {
    border-right: 1px solid ${({ theme }) => theme.colors.gray400};
    padding-right: 16px;
  }
  &:last-child {
    padding-left: 16px;
  }
  &:hover {
    // I need "! important" to fix .RCL_Button__text.RCL_Button__primary:hover
    border-color: ${({ theme }) => theme.colors.gray400} !important;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    font-size: ${({ theme }) => theme.font.size.md};
    line-height: 16px;
  }
`;
export const DialogContentWrapper = styled(DialogScroll)`
  margin: 0 10px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin: 0 20px;
  }
`;
export const DialogContentList = styled.ul`
  break-inside: auto;
  column-count: 1;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-count: 2;
    margin-bottom: 0;
    width: 100%;
  }
  label {
    cursor: pointer;
    margin-bottom: 14px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      margin-bottom: 20px;
    }
  }
`;
export const DialogContentListItemParent = styled.li`
  display: ${({ hasSubTocs }) => (hasSubTocs ? "inline-block" : "block")};
  width: 100%;
`;
export const DialogParentToc = styled(InputCheckbox)`
  font-size: ${({ theme }) => theme.font.size.md};
  line-height: 18px;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  color: ${({ theme }) => theme.colors.gray800};
`;
export const DialogChildToc = styled(InputCheckbox)`
  font-size: ${({ theme }) => theme.font.size.md};
  line-height: 18px;
  font-weight: ${({ theme }) => theme.font.weight.semibold};
  color: ${({ theme }) => theme.colors.gray800};
  margin-left: 35px;
`;
export const DialogContentFooter = styled.div`
  z-index: 100;
  height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  padding: 10px;
  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: 80px;
    justify-content: flex-end;
    flex-direction: row;
    align-items: center;
    width: 100%;
    border-radius: 0 0 3px 3px;
    padding: 0 20px;
  }
`;
